import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { useParams } from 'react-router-dom';
import { FieldForm } from '@app/src/common/FieldForm';
import { InputTitle, fetchOpportunity } from '@app/src/views/StepOne/form';
import { COLORS } from '@app/src/ui';
import { Select } from '@app/src/common/Select';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';

interface Props {
  operationId: number;
}

export const SectionOpportunity: React.FC<Props> = ({ operationId }) => {
  const dispatch = useDispatch();
  const { packageId } = useParams();

  const isLoading = useSelector(state => state.opportunity.isFetching);
  const currentSection = useSelector(state => state.form.stepOne.values.section);
  const sections: SelectItemModel[] = useSelector(state => state.opportunity.data);
  const print = useSelector(state => state.print.general);
  const printSection = useSelector(state => state.print.general.section);

  useEffect(() => {
    dispatch(change('stepOne', 'section', print.section));
    dispatch(change('stepOne', 'sectionName', print.sectionName));
  }, []);

  useEffect(() => {
    if (packageId) {
      dispatch(fetchOpportunity(operationId, packageId));
    } else {
      dispatch(fetchOpportunity(operationId));
    }
    if (operationId !== print.operation) {
      dispatch(change('stepOne', 'section', null));
      dispatch(change('stepOne', 'sectionName', null));
      dispatch(change('stepOne', 'title', ''));
    }
  }, [operationId]);

  useEffect(() => {
    if (printSection !== currentSection) {
      dispatch(change('stepOne', 'title', ''));
    }
  }, [currentSection]);

  const handleChange = (opportunity) => {
    const { id, name } = opportunity;
    dispatch(change('stepOne', 'section', id));
    dispatch(change('stepOne', 'sectionName', name));
  }

  return (
    <React.Fragment>
      <FieldForm label="Sección">
        <Select
          dataList={sections}
          handleChange={handleChange}
          placeholder="Seleccione una sección"
          modalTitle="Sección"
          optionColor={COLORS.VIOLET}
          isLoading={isLoading}
          initialIndex={currentSection}
        />
      </FieldForm>
      { currentSection && <InputTitle placeholder="Ej. Préstamos" />}
    </React.Fragment>
  )
};
